let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6M2Hw")).then(() => parcelRequire('8XEjR'));